import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/USOBConfig";
import axios from "axios";
import {
  analyticsByUserLoading,
  submitAnalyticsByUserActionDispatcher,
  submitAnalyticsByUserErrorDispatcher,
  SUBMIT_ANALYTICS_BY_USER_ACTION_REQUESTED,
} from "./Action"; // Path should come here
import USOBApiRequest from "../../utils/ApiUrls";
import { getAuthUserDetails } from "../../utils/Helpers";

const postAnalyticsByUserAPI = async (postData) => {

 const result= axios.get(USOBApiRequest.USOBApiBaseURL + `/user/time-spent`, {
    headers: {
      "Content-Type": "text/plain",
      userid: getAuthUserDetails()?.usob_id,
      customerid: getAuthUserDetails()?.usob_cid,
      roleid: getAuthUserDetails()?.usob_rid,
    },
    params:postData,
   
  })
  
  return result;
};

function* submitAnalyticsByUserSaga({ postData }) {
  try {
    yield put(analyticsByUserLoading(true));
    const data = yield call(postAnalyticsByUserAPI, postData);
    yield put(submitAnalyticsByUserActionDispatcher(data));
    yield put(submitAnalyticsByUserErrorDispatcher({}));
    yield put(analyticsByUserLoading(false));
  } catch (e) {
    yield put(submitAnalyticsByUserActionDispatcher({}));
    yield put(
      submitAnalyticsByUserErrorDispatcher(e.response.data)
    );
    yield put(analyticsByUserLoading(false));
  }
}

function* submitAnalyticsByUserWatcher() {
  yield takeEvery(SUBMIT_ANALYTICS_BY_USER_ACTION_REQUESTED, submitAnalyticsByUserSaga);
}
export default submitAnalyticsByUserWatcher;
